import React, {FC} from 'react';

interface IRowActionProps {
  title: string;
  onClick: () => void;
  danger?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
}

export const RowAction: FC<IRowActionProps> = ({title, onClick, danger, disabled, children}) => (
  <button
    type="button"
    title={title}
    aria-label={title}
    disabled={disabled}
    onClick={onClick}
    className={`rounded-md p-2 text-gray-400 transition-colors hover:bg-gray-100 disabled:cursor-default disabled:opacity-40 tablet:p-1.5 [&>svg]:h-5 [&>svg]:w-5 tablet:[&>svg]:h-4 tablet:[&>svg]:w-4 ${
      danger ? 'hover:text-[#c2410c]' : 'hover:text-[#654dcb]'
    }`}>
    {children}
  </button>
);
